
import { Step, Field, ITransaction, Transaction } from '../../../core/domain/module';
import { Messages } from '../../../core/enums/messages';
import { Analytics, InternalEventNames, Steps } from '../../../core/services/analytics/module';
import { FieldTypes } from '../../fieldTypes';
import { required, maxLength, minLength } from '../../fieldValidations/module';
import { DefaultSteps } from '../../default';
import { processVerification } from '../../utilities/module';
import { Subscriptions } from '../../../core/services/module';
import { Brands } from '@delta-defense/client-environments';
import { resolveMemberBrand } from '../../../utilities/resolveMemberBrand';
import { shouldUseCabelasBranding } from '../../../utilities/shouldUseCabelasBranding';
import { Routes } from '../../../core/enums/routes';

export enum VerificationLoginFields {
	Code = 'code'
}

const fields = {
	[VerificationLoginFields.Code]: new Field(
		VerificationLoginFields.Code,
		'Verification Code',
		FieldTypes.VerificationCode,
		'A six digit verification code is required.',
		[required, minLength(6), maxLength(6)]
	)
};

export const VerificationLogin = (
	analytics = Analytics.Instance(),
	processVerificationFunc = processVerification,
	transaction?: ITransaction,
	subscriptions = Subscriptions.Instance()
) =>
	new Step(fields, async () => {
		transaction = transaction || Transaction.Instance();

		analytics.TrackInternal({
			event_name: InternalEventNames.VerificationCodeEntered,
			step: Steps.One
		});

		const fields = transaction.Steps[DefaultSteps.VerificationLogin].Fields;
		const verificationCode = fields[VerificationLoginFields.Code].GetValue();

		transaction.Message.Publish(Messages.LoggingIn);
		const result = await processVerificationFunc(verificationCode, transaction.Data.email);
		transaction.Message.Publish(Messages.Empty);

		const customerResult = await subscriptions.getCustomer();
		const expectedBrand = resolveMemberBrand(customerResult.value?.subscriptions || []);
		const currentBrand = shouldUseCabelasBranding() ? Brands.CabelasShield : Brands.USCCA;

		if (expectedBrand !== currentBrand) {
			document.location = `${Routes.Existing}${location.search}`;
		}

		return {
			wasSuccessful: result
		};
	});
